import api from '../api/api';
import {
  CrawlRunResponse,
  WebsiteSourceRequest,
  WebsiteSourceResponse,
  WebsiteSourceSearchResult
} from '../../types/WebsiteSource';
import { SimpleMessage } from '../../types/SimpleMessage';

export interface WebsiteSourceSearchParams {
  page: number;
  resultsPerPage: number;
  sortColumn: string;
  sortDirection: 'ASC' | 'DESC';
}

const baseUrl = (chatbotId: number): string =>
  `chatbots/${chatbotId}/website-sources`;

class WebsiteSourceService {
  static async list(
    chatbotId: number,
    params: WebsiteSourceSearchParams,
    signal?: AbortSignal
  ): Promise<WebsiteSourceSearchResult> {
    const response = await api.get(baseUrl(chatbotId), { params, signal });
    return response.data;
  }

  static async create(
    chatbotId: number,
    request: WebsiteSourceRequest
  ): Promise<WebsiteSourceResponse> {
    const response = await api.post(baseUrl(chatbotId), request);
    return response.data;
  }

  static async update(
    chatbotId: number,
    sourceId: number,
    request: WebsiteSourceRequest
  ): Promise<WebsiteSourceResponse> {
    const response = await api.put(
      `${baseUrl(chatbotId)}/${sourceId}`,
      request
    );
    return response.data;
  }

  static async setEnabled(
    chatbotId: number,
    sourceId: number,
    enabled: boolean
  ): Promise<WebsiteSourceResponse> {
    const response = await api.put(
      `${baseUrl(chatbotId)}/${sourceId}/enabled?enabled=${enabled}`
    );
    return response.data;
  }

  static async delete(
    chatbotId: number,
    sourceId: number
  ): Promise<SimpleMessage> {
    const response = await api.delete(`${baseUrl(chatbotId)}/${sourceId}`);
    return response.data;
  }

  static async runs(
    chatbotId: number,
    sourceId: number
  ): Promise<CrawlRunResponse[]> {
    const response = await api.get(`${baseUrl(chatbotId)}/${sourceId}/runs`);
    return response.data;
  }
}

export default WebsiteSourceService;
